import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getErrorMessage } from "./utils";

interface ErrorState {
    message: string | null;
}

const initialState: ErrorState = {
    message: null,
};

const errorSlice = createSlice({
    name: "error",
    initialState,
    reducers: {
        setError(state, action: PayloadAction<unknown>) {
            // eslint-disable-next-line no-param-reassign
            state.message = getErrorMessage(action.payload);
        },

        clearError(state) {
            // eslint-disable-next-line no-param-reassign
            state.message = null;
        },
    },
});

export const { setError, clearError } = errorSlice.actions;
export default errorSlice.reducer;
